<template>
    <div>
        <v-dialog
            @keydown.27="close"
            @keydown.ctrl.enter="submit"
            v-model="display"
            persistent
            width="500"
            scrollable>
            <v-card flat>
                <v-toolbar dense flat dark color="primary">
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                        <v-icon @click="addPhoneLine">mdi-phone-plus</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else class="mt-4">
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-row>
                            <v-col>
                                <v-text-field
                                    autofocus
                                    outlined
                                    dense
                                    :label="$t('name')"
                                    v-model="form.name"
                                    :rules="rules.name"
                                    hide-details="auto"
                                    :disabled="uneditableField('name')"
                                    >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-autocomplete
                                    :label="$t('customer_group')"
                                    dense
                                    v-model="form.group_id"
                                    outlined
                                    hide-details="auto"
                                    :items="customerGroups"
                                    item-text="name"
                                    item-value="id"
                                    @update:search-input="searchCustomerGroups"
                                    :loading="searchGroupLoading"
                                    >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-for="(phone, index) in form.phones" :key="index">
                            <v-col cols="4" class="my-0">
                                <v-select
                                    multiple
                                    outlined
                                    :items="phoneClasses"
                                    hide-details="auto"
                                    dense
                                    v-model="phone.class"
                                    :rules="rules.class"
                                    :menu-props="{
                                        down: true,
                                        offsetY: true
                                    }"
                                    :label="$t('class')"
                                    >
                                </v-select>
                            </v-col>
                            <v-col cols="8" class="my-0">
                                <v-text-field
                                    dense
                                    :label="$t('phone')"
                                    outlined
                                    hide-details="auto"
                                    v-model="phone.number"
                                    :rules="rules.phone"
                                    onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                    :disabled="uneditableField('phone')"
                                    >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-switch :label="$t('receive_sms_notifications')" v-model="form.receive_sms" :disabled="!eligibleForSMS"></v-switch>
                        <v-row>
                            <v-col>
                                <v-select
                                    v-if="!!form.receive_sms"
                                    label="Prefered Language"
                                    v-model="form.locale"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    :items="locales"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-autocomplete
                                    :label="$t('sale_person')"
                                    dense
                                    v-model="form.sales_person_id"
                                    outlined
                                    hide-details="auto"
                                    :items="salesPeople"
                                    item-text="name"
                                    item-value="id"
                                    @update:search-input="searchSalesPeople"
                                    :loading="searchPeopleLoading"
                                    ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    hide-details="auto"
                                    dense
                                    outlined
                                    :label="$t('email')"
                                    v-model="form.email"
                                    :disabled="uneditableField('email')">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-textarea
                                    rows="2"
                                    :label="$t('adderss')"
                                    v-model="form.address"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    :disabled="uneditableField('address')">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        :disabled="loading.submit || loading.submit"
                        :loading="loading.submit"
                        @click="submit">
                        {{ $t("save_btn" )}}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="close">
                        {{ $t("cancel_btn") }}
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
// 3rd Parties
import { mapActions, mapState } from 'vuex';
import { findIndex, includes, isEmpty } from 'lodash';

// Components
import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog';

// Utils
import uneditableField from '@/utils/uneditableField';

// data
import { locales } from './../../data/locales';

// services
import salesPerson from '../../services/sales/salesPerson';
import CustomerGroup from '../../services/sales/group'
export default {
    name: "CustomerDialog",
    components: {
        RetryDialog,
        AlertDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            valid: false,
            openingBalance: false,
            mode: {
                edit: false
            },
            loading: {
                data: true,
                submit: false
            },
            phoneClasses: [
                // {text: "Calls", value: 1},
                // {text: "SMS", value: 2}
            ],
            form: {
                id: null,
                name: null,
                phone: null,
                address: null,
                phones: [
                    {
                        number: null,
                        class: [1]
                    }
                ],
                receive_sms: false,
                locale: "ar",
                sales_person_id: null,
                group_id: null
            },
            rules: {
                name: [
                    v => !!v || this.$t("rules_required")
                ],
                phone: [
                    v => !v ? true : v.length >= 10 && v.length <= 12 || this.$t('must_be_less'),
                ],
                class: [
                    v => !!v || this.$t("rules_required")
                ]
            },
            locales,
            salesPeople: [],
            customerGroups: [],
            searchPeopleLoading: false,
            searchGroupLoading: false
        }
    },
    computed: {
        ...mapState("sales/customer", ["customer"]),
        ...mapState('authentication', ["authorizations"]),
        title() {
           if(!this.mode.edit) return this.$t('new_customer')
           else return this.$t('edit_customer')
        },
        eligibleForSMS() {
            var index = findIndex(this.form.phones, function(o) {
                return includes(o.class, 2) && !isEmpty(o.number);
            });
            return index == -1 ? false : true;
        }
    },
    methods: {
        ...mapActions("sales/customer", ["fetchCustomers", "fetchCustomer", "storeCustomer", "updateCustomer"]),
        ...mapActions("sales/dpk", ["fetchDpk"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        ...mapActions('sms', ["getCustomersPhoneClasses"]),
        uneditableField,
        open(params) {
            this.mode.edit = params.editMode;
            this.openParams = params;
            this.loading.data = true;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch() {
            try {
                let response = await this.getCustomersPhoneClasses();
                this.phoneClasses = response.data;
                if(this.mode.edit) {
                    await this.fetchCustomer(this.openParams.id);
                    this.form = JSON.parse(JSON.stringify(this.customer));
                    if(this.customer && this.customer.sales_person) {
                        this.salesPeople = [...this.salesPeople, this.customer.sales_person]
                    }
                } else { this.getDpkData(); }
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.form.dpk = dpk.key;
        },
        submit() {
            if(!this.$refs.form.validate()) return;
            this.loading.submit = true;
            if(!this.mode.edit) {
                this.storeCustomer(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    })
                    .catch(error => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            } else {
                this.updateCustomer(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            }
        },
        onRetryDialogSubmit(params) {
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
            }
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.$refs.form.resetValidation();
        },
        removePhone() {
            alert("Phone Removed");
        },
        addPhoneLine() {
            this.form.phones.push({number: null, class: [1]})
        },
        searchSalesPeople(query) {
            this.searchPeopleLoading = true;
            salesPerson.search(query).then(res => {
                this.salesPeople = [...this.salesPeople, ...res.data];
            }).finally(() => {
                this.searchPeopleLoading = false
            })
        },
        searchCustomerGroups(query) {
            this.searchGroupLoading = true;
            CustomerGroup.search(query).then(res => {
                this.customerGroups = [...this.customerGroups, ...res.data];
            }).finally(() => {
                this.searchGroupLoading = false;
            });
        }
    },
    updated() {
        if(!this.eligibleForSMS) this.form.receive_sms = false;
    }
}
</script>